import React from 'react';
import { Link, useLocation } from 'react-router';

const SidebarItem = ({ link }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(link.href);

  return (
    <li key={link.title}>
      <Link
        to={link.href}
        className={`flex items-center gap-4 px-4 py-3 rounded-lg transition-colors ${
          isActive ? 'bg-base-300' : 'hover:bg-base-300'
        }`}
      >
        {link.icon}
        <span>{link.title}</span>
        {link.badge && (
          <span className="badge badge-primary ml-auto">
            {link.badge}
          </span>
        )}
      </Link>
    </li>
  );
};

export default SidebarItem;
